import * as actions from '@actions';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

// NB: take care to ensure that the calling page has initialised before mounting a component using this hook ...
// because WrappedHBSApp in _app resets the query cache as part of initialisation there is a danger that a
// "early" invocation of this hook will get quietly reset.
// see https://github.com/tannerlinsley/react-query/discussions/1363
export interface Policy {
  policy_code: string;
  policy_level: string;
  policy_link: string;
  version_id: number;
  description: string;
  url: string;
  accepted: boolean;
}
export default function usePatientPolicies() {
  const dispatch = useDispatch();

  const { data = [] } = useQuery({
    queryKey: ['allPatientPolicies'],
    queryFn: () => dispatch(actions.allPatientPolicies()),
    select: (data) => data.policies
  });

  return data;
}
